import styled, { css } from 'styled-components';

import { breakpoints, Ratings, Button } from '@notino/react-styleguide';

interface IHeaderProps {
  baseline?: boolean;
}

export const Header = styled.div`
  height: 3.125rem;
  line-height: 3.125rem;
  display: flex;
  align-items: ${(props: IHeaderProps) =>
    props.baseline ? 'baseline' : 'center'};
  font-size: 0.875rem;

  strong {
    font-size: 1.125rem;
    padding-right: 0.3125rem;
  }
`;

export const NoReviewText = styled.div`
  padding-bottom: 1.25rem;
`;

export const OverallValue = styled.span<{ newDesign: boolean }>`
  display: inline-block;
  box-sizing: content-box;
  padding-right: 0.625rem;

  ${({ newDesign }) =>
    newDesign
      ? css`
          font-size: 1.5rem;
          font-weight: 500;
          line-height: 2rem;
        `
      : css`
          font-size: 1.875rem;
          font-weight: bold;
          width: 2.8125rem;
        `}
`;

export const StyledButton = styled(Button)<{ newDesign: boolean }>`
  margin-bottom: 1.25rem;
  font-weight: normal;

  @media (min-width: ${breakpoints.md}) {
    margin: 0;
  }

  ${({ newDesign }) =>
    newDesign &&
    css`
      font-weight: 500;
    `}
`;

export const StyledRatings = styled(Ratings)`
  display: inline-block !important;
`;
